import { z } from "zod";
import { createCommonApiResponseSchema } from "@/server/agentTypes";

export const DocumentsForPagesResultItemSchema = z.object({
  formPageId: z.string(),
  id: z.string(),
  name: z.string(),
  parameters: z.string(),
});

export const DocumentsForPagesRulesSchema = z.record(
  z.string(),
  z.array(DocumentsForPagesResultItemSchema)
);

export const DocumentsForPagesResponseSchema = createCommonApiResponseSchema(
  z.object({
    documentRules: DocumentsForPagesRulesSchema,
  })
);

export const GetFileBodyResponseSchema = createCommonApiResponseSchema(
  z.object({
    data: z.string(),
  })
);

export const DocumentsForRegistrationSchema = createCommonApiResponseSchema(
  z.object({
    documentRules: z.array(DocumentsForPagesResultItemSchema),
  })
);
